// extracted by mini-css-extract-plugin
export default {"buttonsRow":"Accordion_buttonsRow__N2o1Q","loaderContainer":"Accordion_loaderContainer__X+N+o"};